import { render, staticRenderFns } from "./ImprimirBuro.vue?vue&type=template&id=2f46f204&scoped=true&lang=html&"
import script from "./ImprimirBuro.vue?vue&type=script&lang=js&"
export * from "./ImprimirBuro.vue?vue&type=script&lang=js&"
import style0 from "./ImprimirBuro.vue?vue&type=style&index=0&id=2f46f204&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f46f204",
  null
  
)

export default component.exports